// DEPENDENCIES ---------------------------------------------------------------- //

// import React from 'react';

import { Theme, SvgIcon, useTheme } from '@mui/material';

// TYPES ---------------------------------------------------------------- //

interface TileIconHopdriveProps {
  size?: number;
  useTileCorrections?: boolean;
}

// COMPONENT ---------------------------------------------------------------- //

const TileIconHopdrive = ({ size = 24, useTileCorrections = true }: TileIconHopdriveProps) => {
  const theme = useTheme();
  const clsx = useSxStyles(theme);

  return (
    <SvgIcon sx={useTileCorrections ? clsx.iconWithCorrections : clsx.icon} style={{ fontSize: `${size}px` }}>
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 277.17 118.92'>
        <rect fill='currentColor' y='33.38' width='28.43' height='10.78' />
        <rect fill='currentColor' x='26.98' y='53.96' width='29.5' height='10.78' />
        <polygon fill='currentColor' points='95.99 95.15 95.99 105.83 117.23 105.79 110.12 95.15 95.99 95.15' />
        <polygon fill='currentColor' points='42.7 105.93 83.14 105.85 83.14 95.15 42.7 95.14 42.7 105.93' />
        <rect fill='currentColor' x='15.61' y='95.12' width='12.85' height='10.78' />
        <path
          fill='currentColor'
          d='M224.2,70.77c.87-1.26.88-1.26,2.33-.85a58.51,58.51,0,0,0,14,1.91,64.29,64.29,0,0,0,12.33-.31,35.87,35.87,0,0,0,20.69-10.6,11.5,11.5,0,0,0,3.4-10.69,10.45,10.45,0,0,0-7.05-8.43q-14-4.95-28.08-9.85l-16.63-5.84a7.41,7.41,0,0,1-1.77-.77A215.15,215.15,0,0,0,202.73,12a87,87,0,0,0-21.19-8.6A107.41,107.41,0,0,0,159.59.74C155.43.58,151.26.5,147.1.36,143.9.25,140.71,0,137.52,0A7.47,7.47,0,0,0,130,8.47a30.27,30.27,0,0,0,1.16,4.94c2.35,7.8,7.12,13.49,14.77,16.59a46.77,46.77,0,0,0,14.72,3.07c5.54.35,11.08.48,16.62.73,3.61.16,7.22.2,10.81.55,4.84.48,9.65,1.19,14.48,1.83,1.3.17,2.59.43,3.91.65,0,.11,0,.17-.08.19-.72.39-1.44.8-2.17,1.17a56.52,56.52,0,0,1-28.57,6.14c-6.69-.27-13.12-1.85-19.61-3.46-14.5-3.59-21.09-4.48-34.6-6.5-2.65-.4-8.61-.64-14.1-.78l.14,10.58H86.54V33.53l-48.22-.16V44.16H79.69L85.32,54,68.84,54V64.74l21.67.2c2.09,3.31,4.17,6.55,6.17,9.6h-20v10.7l27,0c3,4.53,5.31,8.06,6.37,10l20,.21.55,10.42,7.53-.15c9.63-.36,15.4-1.8,25.42-3.6a11.49,11.49,0,0,0,2.55-1.17l.11.13c-.23.39-.45.79-.68,1.19a23.62,23.62,0,0,0-2.59,5.89c-.83,3.47-.18,6.51,2.68,8.84a10,10,0,0,0,6.11,2,35.19,35.19,0,0,0,10.55-1.4c13-3.45,25.86-7.19,38.46-11.88a81.72,81.72,0,0,1,13.79-4.24,12.72,12.72,0,0,1,9.6,1.7,44.12,44.12,0,0,0,6.08,3.21,23.63,23.63,0,0,0,8.57,2.34c3.56.13,6.88-.56,9.56-3.06s3.93-5.58,3-9.26a8.33,8.33,0,0,0-4.8-5.44,57.53,57.53,0,0,0-7-2.72,104.25,104.25,0,0,1-12.62-4.74,33,33,0,0,0-14.58-3.11A39,39,0,0,0,221,82.22l-2.46.78c.08-.34.12-.55.18-.75A41.46,41.46,0,0,1,224.2,70.77ZM96,64.74V54L129.45,54V64.74Zm52.76,20.4H111.54V74.55h37.21Z'
        />
        <polygon fill='currentColor' points='63.81 74.55 37.02 74.54 37.02 85.33 63.81 85.28 63.81 74.55' />
        <rect fill='currentColor' x='2.76' y='53.96' width='12.85' height='10.78' />
      </svg>
    </SvgIcon>
  );
};

// STYLES ---------------------------------------------------------------- //

const useSxStyles = (theme: Theme) => ({
  icon: {
    display: 'block',
    color: theme.palette.shuttle.main,
  },
  iconWithCorrections: {
    display: 'block',
    marginBottom: '-12px',
    fontSize: '40px',
    color: theme.palette.shuttle.main,
  },
});

// EXPORT ---------------------------------------------------------------- //

export default TileIconHopdrive;
